<script setup lang="ts">
import { config } from "@/lib/variantConfig";
import {
  Magazine,
  Bookmark,
  MobilePhone,
  Article,
  Home,
  XMark,
  Puzzle,
} from "@/components/icons";
import { useAuthStore } from "@/stores/authStore";
import HelpButton from "@/components/help/HelpButton.vue";
import Socials from "@/components/help/Socials.vue";
import { DialogRoot, DialogTrigger } from "reka-ui";
import AppDownloadDialog from "@/components/AppDownloadDialog.vue";
import DialogContent from "@/components/DialogContent.vue";
import LogoSidebar from "@/components/general/LogoSidebar.vue";
import SidebarCta from "@/components/layout/SidebarCta.vue";

const model = defineModel();

const authStore = useAuthStore();

const handleClose = () => {
  model.value = false;
  console.log("MobileSidebar closed");
};
</script>

<template>
  <transition>
    <div
      v-if="model"
      class="fixed inset-0 z-40 bg-background-overlay/40"
      @click="handleClose"
    />
  </transition>
  <transition name="slide-fade">
    <div v-if="model" class="fixed left-0 top-0 z-40 w-full h-full flex">
      <aside
        class="bg-background-primary p-4 overflow-auto h-full w-full max-w-80 flex flex-col"
        @click.prevent
      >
        <RouterLink to="/" @click="handleClose">
          <LogoSidebar class="w-24" />
        </RouterLink>
        <nav>
          <div class="h-px bg-border-primary my-4"></div>
          <ul class="flex flex-col gap-2" @click="handleClose">
            <li>
              <RouterLink to="/" class="sidebar-item">
                <Home size="28" />
                <span>{{ $t("menu.home") }}</span>
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/magazines" class="sidebar-item">
                <Magazine size="28" weight="fill" />
                <span>{{ $t("menu.magazines") }}</span>
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/articles" class="sidebar-item">
                <Article size="28" weight="fill" />
                <span>{{ $t("menu.articles") }}</span>
              </RouterLink>
            </li>
            <li v-if="config.puzzle_page?.type === 'web'">
              <RouterLink to="/puzzles" class="sidebar-item">
                <Puzzle size="28" weight="fill" />
                <span>{{ $t("menu.puzzles") }}</span>
              </RouterLink>
            </li>
            <li v-if="authStore.user">
              <RouterLink to="/saved" class="sidebar-item">
                <Bookmark size="28" weight="fill" />
                <span>{{ $t("menu.saved") }}</span>
              </RouterLink>
            </li>
          </ul>
          <div class="h-px bg-border-primary my-4"></div>
          <SidebarCta class="mb-2" />
          <DialogRoot>
            <DialogTrigger class="sidebar-item-secondary mb-2">
              <MobilePhone size="28" /><span>{{
                $t("menu.download_app")
              }}</span>
            </DialogTrigger>
            <DialogContent>
              <AppDownloadDialog />
            </DialogContent>
          </DialogRoot>
          <HelpButton />
        </nav>
        <div class="mt-auto">
          <Socials />
        </div>
      </aside>
      <div class="mx-2 mt-4 flex-auto" @click="handleClose">
        <button class="btn-round-white" @click="handleClose">
          <XMark />
        </button>
      </div>
    </div>
  </transition>
</template>
